import script from "./Status.vue?vue&type=script&setup=true&lang=ts"
export * from "./Status.vue?vue&type=script&setup=true&lang=ts"

import "./Status.vue?vue&type=style&index=0&id=6a1e8e2c&lang=css"

const __exports__ = script;

export default __exports__